export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/NoBuyingRequests.973c6b35.svg","height":117,"width":271,"blurWidth":0,"blurHeight":0};